import { AppLinkTargetCapability } from '../../apis/eols-app-link/eols-app-link.constants';
import { RoutePath } from '../../components/app/app.constants';

export enum AppLinkRedirectErrorMessage {
  MISSING_COOKIES = 'MISSING_COOKIES',
  EXPIRED_TOKEN = 'EXPIRED_TOKEN',
  INVALID_TOKEN = 'INVALID_TOKEN',
  MISSING_COURSE_SECTION_ID = 'MISSING_COURSE_SECTION_ID',
  UNSUPPORTED_USER_ROLE = 'UNSUPPORTED_USER_ROLE',
  REQUEST_FAILED = 'REQUEST_FAILED',
}

export const AppLinkRedirectErrorMessages: Record<AppLinkRedirectErrorMessage, string> = {
  [AppLinkRedirectErrorMessage.MISSING_COOKIES]: 'Failed to launch by inter app linking: missing cookies',
  [AppLinkRedirectErrorMessage.EXPIRED_TOKEN]: 'Failed to launch by inter app linking: expired token',
  [AppLinkRedirectErrorMessage.INVALID_TOKEN]: 'Failed to launch by inter app linking: invalid token',
  [AppLinkRedirectErrorMessage.MISSING_COURSE_SECTION_ID]: 'Failed to launch by inter app linking: missing courseSectionId',
  [AppLinkRedirectErrorMessage.UNSUPPORTED_USER_ROLE]: 'Failed to launch by inter app linking: user role is not supported',
  [AppLinkRedirectErrorMessage.REQUEST_FAILED]: 'Failed to launch by inter app linking: request(s) failed',
};

export enum AppLinkCookie {
  X_TOKEN = 'x-token',
  X_LINK_ID = 'x-link-id',
}

export const APP_LINK_COOKIE_EXPIRATION_DAYS = 1 / 24;

// A MedEd student returning from Medical Assessment lands on the Courseware page that launched it.
// The returned link keeps the launch's original outPostBody, so its targetCapability identifies
// that page. Capabilities without an entry (e.g. Study's Create a Test) land on Study Home.
export const MedicalAssessmentReturnRoutes: Partial<Record<AppLinkTargetCapability, RoutePath>> = {
  [AppLinkTargetCapability.USMLE_MOCK_EXAM]: RoutePath.TEST_PREP,
  [AppLinkTargetCapability.STUDENT_PERFORMANCE]: RoutePath.STUDENT_PERFORMANCE
};
